<script setup>
import TitleTwo from '@/components/title-des/titleTwo.vue'
</script>

<template>
  <div class="industryPart w-full">
    <div class="w-full">
      <div>
        <TitleTwo
          title="自动化生成报告"
          top="24px"
          bottom="20px"
          sub-title="自动化生成报告，根据客户业务场景深度定制。"
        />
      </div>
      <img
        src="https://static.idicc.cn/cdn/official/H5/research_bottom_bg.png"
        alt=""
        class="w-full mb-4"
      >
    </div>
  </div>
</template>

<style lang="less" scoped>
.industryPart {
  margin-top: 64px;
}
</style>
